import { HttpClient } from './http-client';
import { MockHttpClient } from './mock';

const isMock = process.env.REACT_APP_USE_MOCK === 'true' || true;
const API_ENDPOINT = "http://192.168.1.149:9003/scada/api";

export const API_CLIENT: IHttpApi = isMock
  ? MockHttpClient.setup()
  : HttpClient.setup(API_ENDPOINT);

export interface IHttpApi {
  read_current_user(): Promise<User>;
  current_machine_status(): Promise<MachineStatus>;
  list_orders(): Promise<Order[]>;
  list_alarms(): Promise<HistoricAlarm[]>;
  // list_subcenters(): Promise<SubCenter[]>;

  // update_subcenters(subcenters: SubCenter[]): Promise<void>;
}


export type Response = {
  code: ResponseCodes;
  message: string
  payload: object
}

enum ResponseCodes {
  OK = 0,
  GENERIC_ERROR = -100,
  INVALID_INPUT_VALUE = -101,
  COMMUNICATION_ERROR = -102,
  RESOURCE_BUSY = -103,
  NOT_IMPLEMENTED = -300,
  SK_NOTFOUND = -301,
  CONFIG_ERROR = -302,
  WORKCENTER_NOT_ENABLED = 210
}

export type User = {
  id: string;
  name: string;
  started_at: number;
  role: string;
  is_admin: boolean;
}

type Machine = {
  wc_id: number;
  wc_code: string
  wc_name: string
  wc_ip_address: string
  wc_port: string
  subcenters: SubCenter[]
}

export type SubCenter = {
  sub_ws_id: number;
  sub_ws_code: string
  sub_ws_name: string
  sub_ws_position: string | null
  wc_id: number
}

export type MachineStatus = {
  current: {
    state_start_unix_timestamp: number;
    status_code: W_Status;
    order: string;
    article: string;
    article_description: string;
    program: string;
    goods: number;
    wastes: number;
    expected_goods: number;
    expected_end_time: number;
    energy: number;
    power: number;
    alarms: Alarm[];
    parameters: Parameter[];
    stations: Station[]
  }
  workcenter_info: Machine
  oee: number
}

export enum W_Status {
  SPENTA = 0,
  ERRORE = 1,
  ATTESA = 2,
  ATTREZZAGGIO = 3,
  LAVORAZIONE = 4,
}

type Station = {
  center_id: number;
  status_code: W_Status;
  state_start_unix_timestamp: number;
  order: string;
  article: string;
  article_description: string;
  program: string;
  goods: number;
  wastes: number;
  expected_goods: number;
  expected_end_time: number;
  energy: number;
  power: number;
  alarms: Alarm[];
  parameters: Parameter[];
}

export type Alarm = {
  code: string;
  name: string;
  text: string;
  value: boolean;
  type: "ALARM" | "WARNING";
  unix_start: number;
}

export type HistoricAlarm = {
  al_unix_start: number,
  al_unix_end: number,
  al_id: number;
  wc_id: number;
  ws_id: number;
  al_code: string;
  al_type: "ALARM" | "WARNING";
  al_text: string;
  al_timestamp: string;
  al_start: string;
  al_stop: string;
}

export type Parameter = {
  code: string;
  name: string;
  value: string; // arriverà il valore già formattato
  measurement_unit: string;
}

export type Order = {
  wk_id: number,
  wc_id: number,
  ws_id: number | null,
  re_code: string,
  wk_working_time: number;
  wk_setup_time: number;
  wk_expected_setup_time: number;
  wk_expected_working_time: number;
  wk_goods: number;
  wk_wastes: number;
  wk_energy: number;
  wk_gas: number;
  wk_notes: string | null,
  wk_status_code: OrderStatus;
  wo_code: string;
  wo_ordered_quantity: number;
  ar_code: string;
  ar_name: string;
  wk_timestamp: string;
  wk_datestamp: string;
  wk_unix_start: number;
  wk_unix_finish: number;
}

export enum OrderStatus {
  SCHEDULED = 0,
  READY = 1,
  OPEN = 2,
  CLOSED = 3,
  STANDBY = 4,
  ERROR = 5,
  CANCELED = 6
}